import React from "react";
import { withTranslation } from "react-i18next";
import BCEnvironmentalActivityBase from "./bcEnvironmentalActivityBase";
import BCEnvironmentalIssuancesTable from "./bcEnvironmentalIssuancesTable";
import { getIssuances } from "../../common/services/marketdata/bcEnvironmentalService";

const BCEnvironmentalIssuances = ({ t }) => (
  <BCEnvironmentalActivityBase
    t={t}
    titleKey="BCEnvironmentalIssuances"
    retrievedCountKey="RetrievedBCEnvironmentalIssuances"
    chartTitle="Issuance Quantities by Day"
    downloadFileName="BCEnvironmentalIssuances.xlsx"
    fetchData={getIssuances}
    dateField="issueDate"
    searchFields={["accountName", "projectName", "location", "serialNo"]}
    TableComponent={BCEnvironmentalIssuancesTable}
    exportMapper={(record, formatDateValue) => ({
      IssueDate: formatDateValue(record.issueDate),
      AccountName: record.accountName,
      ProjectName: record.projectName,
      Location: record.location,
      Quantity: record.holdingQuantity,
      StandardName: record.standardName,
      Vintage: record.vintage,
      ProjectType: record.projectType,
      PeriodStartDate: formatDateValue(record.periodStartDate),
      PeriodEndDate: formatDateValue(record.periodEndDate),
      VerifierCompany: record.verifierName,
      SerialNo: record.serialNo,
      UnitType: record.unitType,
      UnitMeasurementName: record.unitMeasurementName,
    })}
  />
);

export default withTranslation(["marketdata"])(BCEnvironmentalIssuances);
